module.exports = __webpack_public_path__ + "static/media/comment.4c0b53a8.svg";